import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import InsuranceCard from "./InsuranceCard";
import EnviroCard from "./EnviroCard";
import Button from "@material-ui/core/Button";
import CardCreditCard from "./CardCreditCard";
import Typography from "@material-ui/core/Typography";
import Image from 'material-ui-image';



const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
});


class NewTopPart extends Component {

    state = {
        age: '',
        name: 'hai',
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { classes } = this.props;
        return (
          
                <div  style = { { backgroundColor:"#f4f3ed" }}>
                <Grid container spacing={24}   >

                    <Grid   item xs={12} sm={12} md={12}  lg={12} xl={12}>
                             
                                    <div     style = { { backgroundColor:"#f4f3ed" }}>
                                       <div  style = { { backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat',  paddingTop:50, paddingBottom:50,  paddingLeft:10}}  >

        {/* <Grid container spacing={24} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:'20' }}>

                                                    <Grid   item xs={0} sm={0}  >

                                                    </Grid>
                                                    <Grid   item xs={4} sm={4}  >
                                                    <Button  variant="outlined" href="#vehicleowner"  style = { { textTransform:'none',textAlign: 'center', alignSelf: 'center',borderSize:'4',borderRadius:'4', bordered:'true', backgroundColor:'transparent',  borderColor:'#e2580d' ,color:'black',
                                                    boxShadow: '1px 3px 5px 2px rgb(226, 88, 13, .3)',fontSize:12}}>
                                                Vehicle Owners
                                                </Button>


                                                </Grid>
                                                <Grid   item xs={4} sm={4}   >
                                                    <Button variant="outlined" href="#towtruck"   style = { { textTransform:'none', textAlign: 'center', alignSelf: 'center',borderSize:'2',borderRadius:'4', bordered:'true', backgroundColor:'transparent',  borderColor:'#0a9110' ,color:'black',
                                                    boxShadow: '1px 3px 5px 2px rgb(10, 145, 16, .3)',fontSize:12}}>
                                                Tow Companies
                                                </Button>

                                                </Grid>
                                                <Grid   item xs={4} sm={4}   >
                                                    <Button variant="outlined" href="#city"   style = { { textTransform:'none', textAlign: 'center', alignSelf: 'center',borderSize:'2',borderRadius:'4', bordered:'true', backgroundColor:'transparent',  borderColor:'#540a91' ,color:'black',
                                                    boxShadow: '1px 3px 5px 2px rgb(84, 10, 145, .3)', fontSize:12}}>
                                                    Municipality
                                                </Button>

                                                </Grid>
                                                <Grid   item xs={0} sm={0}  >

                                                </Grid>

                                                </Grid>  */}
      
                                                  <Grid container spacing={24} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:50 }}>
                                        
                                                    <Grid   item xs={12} sm={6} md={3} lg={3} xl={3} style={{ paddingLeft:5, paddingRight:5, marginTop:20}} >
                                                        <Typography variant="h5" gutterBottom  align="center">
                                                        Save Money
                                                        </Typography>
                                                        
                                                
                                                        <Typography variant="h5"  color = 'secondary'  align="center">
                                                        _____________
                                                        </Typography>
                                                        <div   style = { { marginLeft:30}}>
                                                          <Typography variant="subtitle1" gutterBottom  align="left">
                                                          Cost of getting a ride to a tow company storage lot can be significant!
                                                         </Typography>
                                                            </div>
                                                        <div   style = { {   paddingTop:10, paddingLeft:10}}>
                                                        {/*<CardCreditCard></CardCreditCard>*/}
                                                            {/*<MoneyCard></MoneyCard> */}
                                                             
                                                             <Image src={require("../../images/money1.jpg")} style={
                                                                {
                                                                    flex: 1,
                                                                      resizeMode: 'contain',
                                                                  
                                                                  
                                                                }
                                                            } />
                                                          </div>
                                                          <div>
                                                        < Typography
                                                        component = "p"  style = { {   paddingTop:20}} >
                                                          Getting your vehicle back will cost you some money. The cost can be significant when you consider the time you spend away from your work and business.
                                                        < /Typography>
                                                    
                                                        </div>
                                                    </Grid>
                                                    <Grid    item xs={12} sm={6} md={3} lg={3}   style={{ paddingLeft:5, paddingRight:5, marginTop:20}} >
                                                      <Typography variant="h5" gutterBottom  align="center">
                                                      Save Time
                                                    </Typography>
                                                
                                                    <Typography variant="h5"  color = 'secondary'  align="center">
                                                      _____________
                                                      </Typography>
                                                        <div   style = { { marginLeft:30}}>
                                                      <Typography variant="subtitle1" gutterBottom  align="left">
                                                        Losing your vehicle requires your time to get it back! Time is most precious asset.
                                                    </Typography>
                                                        </div>
                                                        <div   style = { {   paddingTop:10, paddingLeft:10}}>
                                                        {/*<CardCreditCard></CardCreditCard>*/}
                                                            {/*<TimeCard></TimeCard> */}
    
      
                                                            <Image src={require("../../images/time0.png")} style={
                                                            {
                                                                flex: 1,
                                                                  resizeMode: 'contain',
                                                               
                                                            }
                                                        } />
                                                        < Typography
                                                        component = "p" style = { {   paddingTop:20}} >
                                                          Time to get your vehicle back, means time away from your business and family. No one can put any monetary value on time.
                                                        < /Typography>
                                                        </div>
                                                    </Grid>
                                                        <Grid    item xs={12} sm={6} md={3} lg={3}  style={{ paddingLeft:5, paddingRight:5, marginTop:20}} >
                                                          <Typography variant="h5" gutterBottom  align="center">
                                                          Save Insurance
                                                        </Typography>
                                                    
                                                        <Typography variant="h5"  color = 'secondary'  align="center">
                                                            _____________
                                                          </Typography>
                                                            <div   style = { { marginLeft:30}}>
                                                          <Typography variant="subtitle1" gutterBottom  align="left">
                                                            Reduce the possiblity of damage to your vehicle and insurance premium hike!
                                                        </Typography>
                                                            </div>
                                                        <div   style = { {   paddingTop:10, paddingLeft:10}}>
                                                        {/*<CardCreditCard></CardCreditCard>*/}
                                                                 {/*} <InsuranceCard></InsuranceCard> */}
                                                                    <Image src={require("../../images/insurance3.jpg")} style={
                                                                    {
                                                                        flex: 1,
                                                                          resizeMode: 'contain',
                                                                      
                                                                    }
                                                                } />
                                                            < Typography
                                                            component = "p"  style = { {   paddingTop:20}} >
                                                              Every time your vehicle gets towed, you increase the chance of damaging your vehicle.
                                                            < /Typography>
                                                    
                                                        </div>
                                                        </Grid>
    
                                                    <Grid   item xs={12} sm={6} md={3} lg={3}   style={{ paddingLeft:5, paddingRight:5, marginTop:20}} >
                                                      <Typography variant="h5" gutterBottom  align="center">
                                                      Save Environment
                                                    </Typography>
                                                
                                                    <Typography variant="h5"  color = 'secondary'  align="center">
                                                        _____________
                                                      </Typography>
                                                        <div   style = { { marginLeft:30}}>
                                                      <Typography variant="subtitle1" gutterBottom  align="left">
                                                        Reduce Co2 emissions by eliminating unnecessary vehicle traffic!
                                                    </Typography>
                                                        </div>
                                                    <div   style = { {   paddingTop:10, paddingLeft:10}}>
                                                    {/*<CardCreditCard></CardCreditCard>*/}
                                                        {/*<EnviroCard></EnviroCard> */}
                                                        <Image src={require("../../images/IMG_9470.JPG")} style={
                                                        {
                                                            flex: 1,
                                                              resizeMode: 'contain',
                                                           
                                                        }
                                                    } />
                                                    < Typography
                                                    component = "p" style = { {   paddingTop:20}} >
                                                      With your partcipation, you will help to reduce 80,000 metric tons of Co2 emissions in U.S.A every year!
                                                    < /Typography>
                                                
                                                    </div>
                                                    </Grid>
          
                                                  </Grid>
                                         
                                        </div>
                                        
                                    </div>
                               
                    </Grid>



                    </Grid>
        </div>
       
            


    );
    }
}

NewTopPart.propTypes = {
    classes: PropTypes.object.isRequired,
};
//export default BiomassView;
export default withStyles(styles)(NewTopPart);